<template>
    <div class="youdinuan">
        <topTitle title="五有服务" :list="list" :newData="newData"></topTitle>
        <p class="top_p">钱湖柏庭为长者贴心提供舒适过冬解决方案。无论是客厅、餐厅、卧室、卫生间等房间内任一个角落，还是社区内其他室内公共区域，均配备全屋地暖。长者在社区中的任何一个位置都不会感觉寒冷。</p>
        <div class="item_bd">
            <img :src="item.img" alt="" v-for="(item,key) in list2" :key='key'>
        </div>
    </div>
</template>
<script>
    import topTitle from "../rightTopTitle";
    export default {
        name: "youdinuan",
        data() {
            return {
                list: [
                    {
                        title: "【五有】有套房",
                        small_title: "HAVE A SUITE",
                        hasTitle: "有套房",
                    },
                    {
                        title: "【五有】有块地",
                        hasTitle: "有块地",
                    },
                    {
                        title: "【五有】有地暖",
                        hasTitle: "有地暖",
                    },
                    {
                        title: "【五有】有社团",
                        small_title: "HAVE A CLUB",
                        hasTitle: "有社团",
                    },
                    {
                        title: "【五有】有管家",
                        small_title: "HAVE A BUTLER",
                        hasTitle: "有管家",
                    }
                ],
                newData:2,
                list2:[{
                    img:require('../../assets/image/fuwu/dinuan.jpeg')
                }]
            };
        },
        methods: {},
        mounted: function() {},
        components: {
            topTitle
        },
        props: {

        },
    };
</script>
<style scoped="scoped">
    .youdinuan{
        width: 100%;
        height: 100%;

    }
    .top_p {
        margin-top: 0.6625rem;
        text-align: left;
        font-size: 0.35rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 0.675rem;
        text-indent: 2em;
    }
    .item_bd{
        margin-top: 1.1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .item_bd img{
        width:100%;
        /* height: 4.75rem; */
        border-radius: 0.125rem;

    }
</style>